import { LegalPage, LegalSection } from "@/components/LegalPage";

export const Terms = () => (
    <LegalPage title="Terms of Service" updated="July 2026" testId="terms-page">
        <LegalSection title="1. Acceptance of Terms">
            <p>
                By accessing or using RedeemDeals ("the Service"), you agree to these Terms of Service. If you do not
                agree, please do not use the Service.
            </p>
        </LegalSection>
        <LegalSection title="2. The Service">
            <p>
                RedeemDeals provides AI-powered tools that generate websites, web applications, and business tools from
                natural-language descriptions. Features may evolve as the platform improves.
            </p>
        </LegalSection>
        <LegalSection title="3. Accounts">
            <p>
                You are responsible for providing accurate account information and for all activity that occurs under
                your account. Keep your credentials confidential.
            </p>
        </LegalSection>
        <LegalSection title="4. Acceptable Use">
            <p>You agree not to use the Service to create or distribute unlawful, harmful, or infringing content.</p>
            <p>You agree not to abuse, disrupt, or attempt to reverse-engineer the platform or its AI systems.</p>
        </LegalSection>
        <LegalSection title="5. Intellectual Property">
            <p>
                You retain ownership of the content and projects you create with the Service. RedeemDeals retains all
                rights to the platform, its design, and underlying technology.
            </p>
        </LegalSection>
        <LegalSection title="6. Free & Paid Plans">
            <p>
                A free plan is available with usage limits. Paid plans unlock additional features. Plan details may
                change with reasonable notice.
            </p>
        </LegalSection>
        <LegalSection title="7. Disclaimers">
            <p>
                The Service is provided "as is" and "as available", without warranties of any kind, express or implied.
                AI-generated output may require review before production use.
            </p>
        </LegalSection>
        <LegalSection title="8. Limitation of Liability">
            <p>
                To the maximum extent permitted by law, RedeemDeals is not liable for indirect, incidental, or
                consequential damages arising from your use of the Service.
            </p>
        </LegalSection>
        <LegalSection title="9. Changes to These Terms">
            <p>
                We may revise these terms from time to time. Continued use of the Service after changes are posted
                constitutes acceptance of the revised terms.
            </p>
        </LegalSection>
        <LegalSection title="10. Contact">
            <p>
                Questions about these terms? Reach us at{" "}
                <span className="text-white">legal@redeemdeals.com</span>.
            </p>
        </LegalSection>
    </LegalPage>
);
